export const T = {
  dark:"#0D0B08", dark2:"#13100C", dark3:"#1C1710", dark4:"#241F14",
  surface:"#2A2318",
  gold:"#C9A84C", goldLt:"#E8C97A", goldPl:"#F5E6BE",
  goldDim:"rgba(201,168,76,.15)", goldBdr:"rgba(201,168,76,.25)", goldBdrS:"rgba(201,168,76,.52)",
  text:"#E8DFC8", muted:"#8A7A58", subtle:"#5A4E36",
  green:"rgba(74,222,128,.85)", red:"rgba(248,113,113,.85)",
};
export const GLOBAL_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
  @keyframes fyzBokeh  { 0%{opacity:.05;transform:scale(1)} 100%{opacity:.22;transform:scale(1.6)} }
  @keyframes fyzFadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  @keyframes fyzFadeIn { from{opacity:0} to{opacity:1} }
  @keyframes fyzPulse  { 0%,100%{box-shadow:0 0 0 0 rgba(201,168,76,.35)} 50%{box-shadow:0 0 0 10px rgba(201,168,76,0)} }
  @keyframes fyzSpin   { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
  *{box-sizing:border-box;margin:0;padding:0;}
  html{scroll-behavior:smooth;}
  body{background:#0D0B08;font-family:'DM Sans',sans-serif;color:#E8DFC8;overflow-x:hidden;}
  a{text-decoration:none;color:inherit;}
  ::-webkit-scrollbar{width:5px;height:5px;}
  ::-webkit-scrollbar-track{background:transparent;}
  ::-webkit-scrollbar-thumb{background:rgba(201,168,76,.25);border-radius:3px;}

  /* Indic scripts render much larger than Latin at the same pixel
     size because Cormorant Garamond only covers Latin and the browser
     falls back to a system font for Tamil/Hindi/etc. Scale down ALL
     display-size Cormorant blocks (and Cormorant body copy) so visual
     heading hierarchy matches the English layout. Values are capped
     below the *smallest* English h1 max (clamp(26px,3vw,38px)) so we
     always scale down, never up. Inline styles are overridden with
     !important. */
  html[lang="ta"] h1, html[lang="hi"] h1, html[lang="te"] h1,
  html[lang="kn"] h1, html[lang="bn"] h1, html[lang="ml"] h1,
  html[lang="mr"] h1 {
    font-size: clamp(18px, 2.3vw, 30px) !important;
    line-height: 1.28 !important;
  }
  html[lang="ta"] h1 em, html[lang="hi"] h1 em, html[lang="te"] h1 em,
  html[lang="kn"] h1 em, html[lang="bn"] h1 em, html[lang="ml"] h1 em,
  html[lang="mr"] h1 em,
  html[lang="ta"] h2 em, html[lang="hi"] h2 em, html[lang="te"] h2 em,
  html[lang="kn"] h2 em, html[lang="bn"] h2 em, html[lang="ml"] h2 em,
  html[lang="mr"] h2 em {
    font-size: inherit !important;
  }
  html[lang="ta"] h2, html[lang="hi"] h2, html[lang="te"] h2,
  html[lang="kn"] h2, html[lang="bn"] h2, html[lang="ml"] h2,
  html[lang="mr"] h2 {
    font-size: clamp(14px, 1.7vw, 22px) !important;
    line-height: 1.3 !important;
  }
  /* Section titles + card titles use <div> with Cormorant inline
     font-size. Target those too via a :lang() + class hook. Pages
     that want the scale should put .fyz-cormorant on the element. */
  html[lang="ta"] .fyz-cormorant, html[lang="hi"] .fyz-cormorant,
  html[lang="te"] .fyz-cormorant, html[lang="kn"] .fyz-cormorant,
  html[lang="bn"] .fyz-cormorant, html[lang="ml"] .fyz-cormorant,
  html[lang="mr"] .fyz-cormorant {
    font-size: 0.78em !important;
    line-height: 1.3 !important;
  }
`;
